<!-- src/Components/admin/UnknownQuestionsDialog.vue -->
<template>
  <el-dialog
    title="未知问题TOP榜"
    :visible.sync="dialogVisible"
    width="1000px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <!-- 筛选条件栏 -->
    <div class="filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        style="width: 240px;"
        @change="onDateChange"
      />
      <el-input
        v-model="keyword"
        placeholder="搜索问题关键词"
        size="small"
        clearable
        style="width: 200px; margin-left: 12px;"
        @keyup.enter.native="onSearch"
        @clear="onSearch"
      >
        <i slot="prefix" class="el-icon-search"></i>
      </el-input>
      <el-button type="primary" size="small" @click="onSearch" style="margin-left: 12px;">
       <svg t="1784342476693" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1671" width="12" height="12"><path d="M795.927273 512c0 13.963636 9.309091 23.272727 23.272727 23.272727s23.272727-9.309091 23.272727-23.272727c0-181.527273-148.945455-330.472727-330.472727-330.472727-13.963636 0-23.272727 9.309091-23.272727 23.272727s9.309091 23.272727 23.272727 23.272727c155.927273 0 283.927273 128 283.927273 283.927273z" fill="#ffffff" p-id="1672"></path><path d="M840.145455 807.563636c69.818182-79.127273 114.036364-181.527273 114.036363-295.563636 0-244.363636-197.818182-442.181818-442.181818-442.181818S69.818182 267.636364 69.818182 512c0 74.472727 18.618182 146.618182 53.527273 211.781818 6.981818 11.636364 20.945455 16.290909 32.581818 9.309091 11.636364-6.981818 16.290909-20.945455 9.309091-32.581818C132.654545 644.654545 116.363636 577.163636 116.363636 512c0-218.763636 176.872727-395.636364 395.636364-395.636364s395.636364 176.872727 395.636364 395.636364-176.872727 395.636364-395.636364 395.636364c-79.127273 0-155.927273-23.272727-221.090909-67.490909-11.636364-6.981818-25.6-4.654545-32.581818 6.981818-6.981818 11.636364-4.654545 25.6 6.981818 32.581818C337.454545 928.581818 423.563636 954.181818 512 954.181818c114.036364 0 216.436364-44.218182 295.563636-114.036363l107.054546 107.054545c4.654545 4.654545 11.636364 6.981818 16.290909 6.981818s11.636364-2.327273 16.290909-6.981818c9.309091-9.309091 9.309091-23.272727 0-32.581818l-107.054545-107.054546z" fill="#ffffff" p-id="1673"></path></svg>
        查询
      </el-button>
      <el-button size="small" @click="handleExport">
        <i class="el-icon-download"></i> 导出
      </el-button>
      <span style="margin-left: 16px; color: #909399; font-size: 13px;">
        共 {{ total }} 条未知问题
      </span>
      <br/>
      <a  clss="tips">建议参照未知问题完善知识库文档</a>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%; margin-top: 12px;"
      max-height="500"
      :default-sort="{prop: 'occurrenceCount', order: 'descending'}"
    >
      <el-table-column label="排名" width="70" align="center">
        <template slot-scope="{ $index }">
          <span v-if="$index === 0" style="font-size: 20px;">🥇</span>
          <span v-else-if="$index === 1" style="font-size: 20px;">🥈</span>
          <span v-else-if="$index === 2" style="font-size: 20px;">🥉</span>
          <span v-else>{{ $index + 1 + page * size }}</span>
        </template>
      </el-table-column>
      <el-table-column label="问题内容" min-width="250">
        <template slot-scope="{ row }">
          <el-tooltip
            :content="row.question"
            placement="bottom"
            :disabled="!isOverflow"
            popper-class="custom-tooltip"
          >
            <span class="ellipsis-text">{{ row.question }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="occurrenceCount" label="出现次数" width="100" align="center" sortable="custom" />
      <el-table-column label="占比" width="180">
        <template slot-scope="{ row }">
          <el-progress :percentage="row.percentage" :stroke-width="15" :text-inside="true" :status="row.percentage > 10 ? 'exception' : 'success'"></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="首次出现" width="170" align="center">
        <template slot-scope="{ row }">
          {{ row.firstSeenTime }}
        </template>
      </el-table-column>
      <el-table-column label="最近出现" width="170" align="center">
        <template slot-scope="{ row }">
          {{ row.lastSeenTime }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="page + 1"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getTopUnknownQuestions } from '@/api/dashboard'

export default {
  name: 'UnknownQuestionsDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      page: 0,
      size: 20,
      dateRange: this.getDefaultDateRange(),
      keyword: '',
      pickerOptions: {
        shortcuts: [
          { text: '近7天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }},
          { text: '近30天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }},
          { text: '近90天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }}
        ]
      }
    }
  },
  computed: {
    tenantId() {
      return this.$store.getters['auth/currentTenant']?.tenantId || null
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.page = 0
      this.dateRange = this.getDefaultDateRange()
      this.keyword = ''
      this.loadData()
    },
    close() {
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    getDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 30)
      return [this.formatDate(start), this.formatDate(end)]
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    onDateChange() {
      this.page = 0
      this.loadData()
    },
    onSearch() {
      this.page = 0
      this.loadData()
    },
    onPageChange(page) {
      this.page = page - 1
      this.loadData()
    },
    onSizeChange(size) {
      this.size = size
      this.page = 0
      this.loadData()
    },
    isOverflow(el) {
      return el?.scrollWidth > el?.clientWidth
    },
    async handleExport() {
      // TODO: 实现导出功能，可以参考 FeedbackDetailDialog 的导出
      this.$message.info('导出功能开发中...')
    },
    async loadData() {
      if (!this.tenantId) {
        this.$message.warning('请先登录')
        return
      }

      this.loading = true
      try {
        const params = {
          tenantId: this.tenantId,
          startTime: this.dateRange[0] + ' 00:00:00',
          endTime: this.dateRange[1] + ' 23:59:59',
          page: this.page,
          size: this.size,
          keyword: this.keyword || undefined
        }

console.log("【DEBUG】实际发送的 tenantId:", params.tenantId, typeof params.tenantId)
console.log("【DEBUG】完整参数:", JSON.stringify(params, null, 2))        
        const res = await getTopUnknownQuestions(params)
        console.log('未知问题TOP榜响应:', res)

        if (res?.data?.code === 200) {
          const data = res.data.data
          this.tableData = data?.content || []
          this.total = data?.totalElements || 0
          this.page = data?.number || 0
        } else {
          this.$message.error(res?.data?.message || '加载失败')
          this.tableData = []
          this.total = 0
        }
      } catch (error) {
        console.error('加载未知问题TOP榜失败:', error)
        this.$message.error('加载失败: ' + (error.message || '未知错误'))
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px 20px 10px 20px;
}

.ellipsis-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.custom-tooltip {
  z-index: 9999999 !important; 
}
.tips{
  font-family: 微软雅黑;
  font-size: small;
  color: red;
}
</style>